import { type PropsWithChildren } from 'react';
import { type ComponentWall, WALL_TYPE } from '@cx-sdk/cvms';
import clsx from 'clsx';

import { type Repub, REPUBS } from '@cx-modules/constants';

import { useTrackCTAImpression } from '~/hooks/use-track-cta-impression';
import {
  useAuthModal,
  VIEW_LOGIN,
  VIEW_SIGNUP } from
'~/providers/auth-modal-provider';

import styles from './styles/ComponentWall.module.css';
import { Button, Card, List } from './cxy';

export function ComponentWall({
  currentPath,
  repub,
  resourcesUrl,
  userHasCancelledSubscription,
  wallType,
  ...props






}: {currentPath: string;repub: Repub;resourcesUrl: string;userHasCancelledSubscription: boolean;wallType?: ComponentWall['type'];} & PropsWithChildren) {
  const { openAtView } = useAuthModal();
  const isPaywall = wallType === WALL_TYPE.PAYWALL;

  const ref = useTrackCTAImpression({
    wallType,
    title: 'oddschecker_plus'
  });

  return (
    <Card
      borderRadius="l"
      {...props}
      className={styles.padlockCard}
      data-testid="component-wall">

			{isPaywall ?
      <a
        className={clsx(styles.link, styles.mobileView)}
        data-testid="sign-up-button-1"
        href={`${repub === REPUBS.OC.name ? '' : `/${repub.toLowerCase()}`}/plus?redirectTo=${currentPath}#plans`}>

					{userHasCancelledSubscription ?
        'Subscribe Now' :
        'Start 7-Day Free Trial'}
				</a> :

      <Button
        className={clsx(styles.button, styles.mobileView)}
        data-testid="sign-up-button-1"
        onClick={(e) => {
          e.preventDefault();
          openAtView(VIEW_SIGNUP);
        }}
        size="large"
        variant="secondary">

					Sign up for free access
				</Button>
      }
			<img
        alt="Padlock"
        className={styles.padlock}
        src={`${resourcesUrl}/assets/img/plus/padlock.svg`} />

			<div className={styles.contentWrapper} ref={ref}>
				<h2 className={styles.title}>
					Gain access to <span>Industry-Leading</span> Data and AI
				</h2>
				<p className={styles.text} data-testid="description">
					Bet smarter with our full suite of cutting-edge tools and metrics
					designed to help you find long-term profitability. 
				</p>
				<List
          className={styles.list}
          data-testid="padlock-list"
          direction="column"
          items={[
          'Positive Expected Value Bets',
          'AI Probabilities for each bet',
          'Public Betting Splits',
          'Trends and insights across all major prop markets',
          'Custom Betslip']
          }
          size="s" />

			</div>
			<div className={styles.ctaWrapper}>
				{isPaywall ?
        <>
						<a
            className={styles.link}
            data-testid="sign-up-button-2"
            href={`${repub === REPUBS.OC.name ? '' : `/${repub.toLowerCase()}`}/plus?redirectTo=${currentPath}#plans`}>

							{userHasCancelledSubscription ?
            'Subscribe Now' :
            'Start 7-Day Free Trial'}
						</a>
						<p className={styles.text} data-testid="login">
							Already subscribed? Please{' '}
							<Button
              className={styles.ghostButton}
              onClick={(e) => {
                e.preventDefault();
                openAtView(VIEW_LOGIN);
              }}
              variant="ghost">

								Log in
							</Button>
						</p>
					</> :

        <>
						<Button
            className={clsx(styles.button, styles.mainButton)}
            data-testid="sign-up-button-2"
            onClick={(e) => {
              e.preventDefault();
              openAtView(VIEW_SIGNUP);
            }}
            size="large"
            variant="secondary">

							Sign up for free access
						</Button>
						<p className={styles.text} data-testid="login">
							Already have an account? Please{' '}
							<Button
              className={styles.ghostButton}
              onClick={(e) => {
                e.preventDefault();
                openAtView(VIEW_LOGIN);
              }}
              variant="ghost">

								Log in
							</Button>
						</p>
					</>
        }
			</div>
		</Card>);

}